<template>
  <div class="home-market">
    <!-- 标题区域 -->
    <div v-if="categoryList.length >= 1" class="section-title-wrapper">
      <span v-for="(item, idx) in categoryList" :key="idx" class="title-item">
        <a 
          v-if="item.templatePath" 
          :href="item.templatePath + '?categoryId=' + item.id" 
          target="_blank"
        >
          {{ item.name }}
        </a>
        <span v-else>{{ item.name }}</span>
        <span v-if="idx < categoryList.length - 1 && item.templatePath" class="title-separator">·</span>
      </span>
    </div>
    <div v-else class="market-title"></div>
    
    <div class="market-divider">
      <div class="divider-thick"></div>
      <div class="divider-thin"></div>
    </div>
    <div class="market-content">
      <div class="link-row">
        <a v-for="(item, idx) in newsList.slice(0, 3)" :key="idx" :href="'/zp/a/' + item.newsCode" target="_blank">{{ item.title }}</a>
      </div>
      <div class="link-row">
        <a v-for="(item, idx) in newsList.slice(3, 6)" :key="idx+3" :href="'/zp/a/' + item.newsCode" target="_blank">{{ item.title }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../../api/request'

export default {
  name: 'HomeMarket',
  data() {
    return {
      categoryList: [],
      newsList: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const res = await request.post('/api/index/getIndexRecommendInfo', { positionKey: 'index_market' })
        if (res.code === 200 && res.data) {
          this.categoryList = res.data.categoryList || []
          console.log('categoryList', this.categoryList.length)
          this.newsList = res.data.newsList || []
        }
      } catch (e) {
        console.error('数据加载失败', e)
      }
    }
  }
}
</script>

<style scoped>
.home-market {
  width: 1400px;
  margin: 0 auto;
  padding-top: 6px;
  box-sizing: border-box;
}
.section-title {
  width: 136px;
  height: 45px;
  color: rgba(185, 24, 22, 1);
  font-size: 34px;
  font-family: 'Microsoft YaHei', sans-serif;
  text-align: left;
  white-space: nowrap;
  line-height: 34px;
  margin-left: -2px;
}

/* 标题容器 */
.section-title-wrapper {
  display: inline-block;
}

.section-title-wrapper .title-item {
  display: inline;
}

.section-title-wrapper a {
  display: inline;
  color: #B91816;
  font-size: 34px;
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 34px;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
}

.section-title-wrapper a:hover {
  color: #C00513;
  text-decoration: underline;
}

/* 分隔符：独立 span，不是超链接 */
.section-title-wrapper .title-separator {
  display: inline;
  color: #B91816;
  font-size: 34px;
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 34px;
  margin: 0 8px;
  cursor: default;
  user-select: none;
}
.market-divider {
  margin-top: 10px;
}
.divider-thick {
  width: 1400px;
  height: 4px;
  background-color: rgba(185, 24, 22, 1);
}
.divider-thin {
  width: 1400px;
  height: 2px;
  background-color: rgba(185, 24, 22, 1);
  margin-top: 3px;
}
.market-content {
  width: 1400px;
  height: 130px;
  background-color: rgba(254, 245, 245, 1);
  box-sizing: border-box;
  padding: 20px 0 0 49px;
}
.link-row {
  width: 1302px;
  height: 24px;
  display: flex;
  align-items: center;
}
.link-row + .link-row {
  margin-top: 37px;
}
.link-row a {
  display: block;
  height: 24px;
  color: rgba(102, 102, 102, 1);
  font-size: 18px;
  font-family: 'Microsoft YaHei', sans-serif;
  text-align: center;
  white-space: nowrap;
  line-height: 24px;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
}
.link-row a:nth-child(1) {
  width: 382px;
}
.link-row a:nth-child(2) {
  width: 348px;
  margin-left: 70px;
}
.link-row a:nth-child(3) {
  width: 432px;
  margin-left: 70px;
}
.link-row a:hover {
  color: rgba(185, 24, 22, 1);
}
</style>
